<div class="slider-range">
  <input
    type="range"
    class="min-value"
    [(ngModel)]="value1"
    name="value1"
    (ngModelChange)="sliderValueChange()"
    [step]="step"
    [min]="min"
    [max]="max"
    (change)="change.emit()"
  >
  <input
    type="range"
    class="max-value"
    [(ngModel)]="value2"
    name="value2"
    (ngModelChange)="sliderValueChange()"
    [step]="step"
    [min]="min"
    [max]="max"
    (change)="change.emit()"
  >
  <span class="slider-fill" #sliderFill></span>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/slider-base/slider-base.component.html